const FreeHighlight = (props) => {
    return <div className={`text-center text-2xl font-semibold ${props.className}`}>
        It's
        <span className="relative mr-3 ml-4 px-2 whitespace-nowrap">
            <span className="absolute -inset-1 block -skew-y-3 bg-green-500" aria-hidden="true"></span>
            <span className="relative text-white">Free!</span>
        </span>
    </div>
}

export default FreeHighlight;